import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import * as ROUTES from "../../../Router/corporate_routes";
import { FRONTEND as CORPORATE_ROUTES } from "../../../Router/corporate_routes";
import { FRONTEND as SITE_VISITS_ROUTES } from "../../../Router/site_visit_routes";
import { ButtonBrand, ButtonPrimary } from "../../Button";
import { LiveSearchSimple } from "../../Form/LiveSearch/LiveSearchSimple";
import { agencyHasFeature } from "../../../modules/auth";
import { AGENCY_PERMISSIONS } from "../../../constants";
import { FRONTEND as PUBLIC_ROUTES } from "../../../Router/public_routes";
import { FRONTEND as ADMIN_ROUTES } from "../../../Router/admin_routes";

const AgencyDashboardNavigation = ({
                                     agencies,
                                     canAccessAgencyCalendar,
                                     newsletterLink,
                                   }) => {
  const [company, setCompany] = useState();
  const history = useHistory();

  useEffect(() => {
    if (company?.id) {
      history.push(ROUTES.FRONTEND.COMPANY.VIEW.replace(":id", company.id));
    }
  }, [company, history]);

  const navLinks = [
    { label: "Home", link: PUBLIC_ROUTES.HOME, visible: true },
    {
      label: "Welcome",
      link: ADMIN_ROUTES.WELCOME,
      visible: true,
      color: "#9bcb41",
    },
    {
      label: "Calendar",
      link: CORPORATE_ROUTES.AGENCY.CALENDAR,
      visible: canAccessAgencyCalendar,
      color: "#FCA342",
    },
    {
      label: "My RFPs",
      link: ADMIN_ROUTES.MY_RFPS,
      visible: true,
      color: "#CB414B",
    },
    {
      label: "Site Visits",
      link: SITE_VISITS_ROUTES.VIEW,
      visible: true,
      color: "#4BC7FE",
    },
    {
      label: "Latest Newsletter",
      link: newsletterLink,
      visible: newsletterLink,
      color: "#E6144C",
      external: true,
    },
  ];

  return (
    <div className="flex flex-wrap items-center w-full mt-8 mb-12">
      <div className="flex items-center flex-wrap">
        {navLinks.map(({ label, link, color, external = false, visible }) => {
          if (!visible) return null;

          const button = (
            <ButtonPrimary
              classes="mr-2 agency-dash-link__home mb-2"
              style={{ width: "inherit", backgroundColor: color }}
            >
              {label}
            </ButtonPrimary>
          );

          return external ? (
            <a href={link} key={link} target="_blank" rel="noopener noreferrer">
              {button}
            </a>
          ) : (
            <Link to={link} key={link}>
              {button}
            </Link>
          );
        })}
      </div>
      <div className="ml-auto flex flex-wrap items-center mt-4 md:mt-0">
        <Link to={`${PUBLIC_ROUTES.ENQUIRY.NEW}`} className="mr-2 mb-2">
          <ButtonBrand classes="agency-dash-link__home">
            New Enquiry
          </ButtonBrand>
        </Link>
        <ButtonPrimary
          classes="agency-dash-link__home mr-2 mb-2"
          onClick={() => {
            const panel = document.getElementById("searchPanel");
            const input = document.getElementById("location-search");

            if (panel) {
              panel.scrollIntoView({ behavior: "smooth", block: "start" });
            }

            setTimeout(() => {
              if (input) {
                input.focus();
              }
            }, 500);
          }}
        >
          Search Venues
        </ButtonPrimary>
        <LiveSearchSimple
          key={company?.id || "empty"}
          id="companySearchNav"
          label={""}
          auth
          classes="mb-2"
          fieldClassName={"max-w-full border-2 border border-grey-md"}
          placeholder="View a company"
          initQuery={company?.name}
          getText={result => result.name}
          url={
            window.API +
            ROUTES.API.COMPANIES.SEARCH +
            "?agencyIds=" +
            agencies.map(a => a.id).join(",")
          }
          onChange={selectedCompany => {
            setCompany(selectedCompany);
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    canAccessAgencyCalendar: agencyHasFeature(
      state.auth,
      AGENCY_PERMISSIONS.CAN_VIEW_AGENTS_CALENDAR
    ),
  };
};

export default connect(mapStateToProps, null)(AgencyDashboardNavigation);